import React  from "react";

export const countrycsvheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Country", key: "countryName" },
    { label: "City", key: "cityName" },
    { label: "Scans", key: "totalScanCount" }
  ];
  
  export const Citycsvheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Country", key: "countryName" },
    { label: "City", key: "cityName" },
    { label: "Scans", key: "totalScanCount" },
    { label: "Image", key: "image" },
    { label: "QR Code Name", key: "itemName" }
  
  ];
  export const Categorycsvheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Category", key: "categoryName" },
    { label: "Subcategory", key: "subCategoryName" },
    { label: "Scans", key: "totalScanCount" },
  ];
  
  export const Subcategorycsvheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Category", key: "categoryName" },
    { label: "Subcategory", key: "subCategoryName" },
    { label: "Scans", key: "totalScanCount" },
    { label: "Image", key: "image" },
    { label: "QR Code Name", key: "itemName" }
  ];
  
  export const Lablecsvheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Lable", key: "categoryName" },
    { label: "Scans", key: "totalScanCount" },
    { label: "Image", key: "image" },
    { label: "QR Code Name", key: "itemName" }
  ];
  

  export const Vendorheaders = [
    { label: "Sr #", key: "sr" },
    { label: "Vendor Name", key: "vendorName" },
    { label: "Logo", key: "vendorLogo" },
    { label: "QR Code Name", key: "productName" },
    { label: "Image", key: "productImagepath" },
    { label: "Total Scans", key: "totalScanCount" }
  
  ];